import { useEffect } from "react";
import LegalDocumentContent from "../components/LegalDocumentContent";
import { privacySections } from "../content/privacy";
import { useLang, useT } from "../i18n";
import { pageSubtitle, pageTitle } from "../lib/ui";

export default function PrivacyPage() {
  const translate = useT();
  const { lang } = useLang();

  useEffect(() => {
    document.title = translate("privacyPageTitle");
  }, [translate]);

  return (
    <section className="py-16 sm:py-24" aria-labelledby="privacy-page-heading">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <h1 id="privacy-page-heading" className={pageTitle}>
          {translate("privacyPageTitle")}
        </h1>
        <p className={pageSubtitle}>{translate("privacyPageUpdated")}</p>

        <div className="mt-10 flex flex-col gap-8">
          {privacySections(lang).map((section) => (
            <section key={section.title} aria-labelledby={`privacy-${section.title}`}>
              <h2 id={`privacy-${section.title}`} className="font-display text-lg font-semibold">
                {section.title}
              </h2>
              <LegalDocumentContent blocks={section.blocks} />
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}
